import { ResponseStatus } from "@/domain/entities/agenda/AgendaItemResponseStatus";
import EventDetail, {
    MeetingMessageType,
    MeetingRequestType,
} from "@/domain/entities/emails/EventDetail";
import { LinkedEventDetails } from "@cs_teamwaydev/mailvista-sdk_react";
import eventLocationMapper from "../eventLocationMapper";

const mapMeetingMessageType = (type: string): MeetingMessageType => {
    switch (type) {
        case "meetingRequest":
            return MeetingMessageType.MEETING_REQUEST;
        case "meetingAccepted":
            return MeetingMessageType.MEETING_ACCEPTED;
        case "meetingDeclined":
            return MeetingMessageType.MEETING_DECLINED;
        case "meetingTentative":
            return MeetingMessageType.MEETING_TENTATIVE;
        case "meetingCancelled":
            return MeetingMessageType.MEETING_CANCELLED;
        case "meetingUpdated":
            return MeetingMessageType.MEETING_UPDATED;
        default:
            return MeetingMessageType.MEETING_REQUEST; // fallback
    }
};

const mapMeetingRequestType = (type: string): MeetingRequestType => {
    switch (type) {
        case "meetingRequest":
            return MeetingRequestType.MEETING_REQUEST;
        case "meetingResponse":
            return MeetingRequestType.MEETING_RESPONSE;
        case "meetingCancellation":
            return MeetingRequestType.MEETING_CANCELLATION;
        case "meetingUpdate":
            return MeetingRequestType.MEETING_UPDATE;
        default:
            return MeetingRequestType.MEETING_REQUEST; // fallback
    }
};

const mapUserResponseStatus = (status: string): ResponseStatus | undefined => {
    if (!status) return undefined;

    switch (status) {
        case "none":
            return ResponseStatus.None;
        case "organizer":
            return ResponseStatus.Organizer;
        case "tentativelyAccepted":
            return ResponseStatus.TentativelyAccepted;
        case "accepted":
            return ResponseStatus.Accepted;
        case "declined":
            return ResponseStatus.Declined;
        case "notResponded":
            return ResponseStatus.NotResponded;
        default:
            return undefined;
    }
};

const eventDetailMapper = (
    eventSentDateTime: Date,
    eventDetail: LinkedEventDetails,
): EventDetail =>
    new EventDetail({
        eventSentDateTime,
        startDateTime: eventDetail.startDateTime
            ? new Date(eventDetail.startDateTime)
            : undefined,
        endDateTime: eventDetail.endDateTime
            ? new Date(eventDetail.endDateTime)
            : undefined,
        meetingMessageType: mapMeetingMessageType(
            eventDetail.meetingMessageType,
        ),
        meetingRequestType: mapMeetingRequestType(
            eventDetail.meetingRequestType,
        ),
        subject: eventDetail.subject,
        isAllDay: eventDetail.isAllDay,
        responseRequested: eventDetail.responseRequested,
        isDelegated: eventDetail.isDelegated,
        location: eventDetail.location
            ? eventLocationMapper(eventDetail.location)
            : undefined,
        id: eventDetail.id,
        userResponseStatus: mapUserResponseStatus(
            eventDetail.userResponseStatus,
        ),
    });

export default eventDetailMapper;
